<script lang="ts">
  import { formatDateTime, formatMoney } from '$lib/format';
  import { t } from '$lib/i18n/index.svelte';
  import { defang } from '$lib/protocol/link-guard';
  import type { OrderElement } from '$lib/protocol/types';

  let { element }: { element: OrderElement } = $props();

  const stateKey = $derived(`el.order.state.${element.state}` as const);
</script>

<div class="order">
  <div class="head">
    <strong>{t('el.order.title')}</strong>
    <span class="chip {element.state}">{t(stateKey)}</span>
  </div>
  {#if element.distributorReference !== undefined}
    <p class="meta">{t('el.order.reference', { ref: defang(element.distributorReference) })}</p>
  {/if}
  {#if element.items.length > 0}
    <ul>
      {#each element.items as item (item.itemId)}
        <li>
          <span>{defang(item.name)} × {item.quantity}{item.unit !== undefined ? ` ${item.unit}` : ''}</span>
          {#if item.total !== undefined}<span>{formatMoney(item.total)}</span>{/if}
        </li>
      {/each}
    </ul>
  {/if}
  {#if element.total !== undefined}
    <div class="total"><span>{t('el.cart.total')}</span><strong>{formatMoney(element.total)}</strong></div>
  {/if}
  {#if element.expectedDelivery !== undefined}
    <p class="meta">{t('el.order.expected', { date: formatDateTime(element.expectedDelivery) })}</p>
  {/if}
</div>

<style>
  .order {
    min-width: 220px;
  }
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
  }
  .chip {
    font-size: 12px;
    border-radius: 999px;
    padding: 3px 10px;
    background: var(--surface-2);
    color: var(--ink-soft);
    white-space: nowrap;
  }
  .chip.delivered {
    background: var(--bubble-mine);
    color: var(--brand);
  }
  .chip.cancelled {
    background: var(--warn-bg);
    color: var(--warn-ink);
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 14px;
  }
  li {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 2px 0;
  }
  .total {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--line);
    margin-top: 6px;
    padding-top: 6px;
  }
  .meta {
    margin: 4px 0 0;
    font-size: 13px;
    color: var(--ink-soft);
  }
</style>
